const goodList =[
  {
      "foodId": 4,
      "name": "ACEROLA",
      "category": "FRUIT",
      "subCat": "DRUPE",
      "description": "ACEROLA,(WEST INDIAN CHERRY),RAW",
      "fdcId": 9001,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 5,
      "name": "ACORNS",
      "category": "OTHER",
      "subCat": "FLOUR",
      "description": "ACORN FLOUR,FULL FAT",
      "fdcId": 12060,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 13,
      "name": "AMARANTH",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "AMARANTH LEAVES,RAW",
      "fdcId": 11003,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 1,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 14,
      "name": "AMARANTH",
      "category": "SEED",
      "subCat": "PSUEDO",
      "description": "AMARANTH,UNCKD",
      "fdcId": 20001,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 1,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 18,
      "name": "ANTELOPE",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,ANTELOPE,CKD,RSTD",
      "fdcId": 17145,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 19,
      "name": "ANTELOPE",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,ANTELOPE,RAW",
      "fdcId": 17144,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 23,
      "name": "APRICOTS",
      "category": "FRUIT",
      "subCat": "DRUPE",
      "description": "APRICOTS,RAW",
      "fdcId": 9021,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 24,
      "name": "ARROWHEAD",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "ARROWHEAD,RAW",
      "fdcId": 11005,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 25,
      "name": "ARROWROOT",
      "category": "OTHER",
      "subCat": "FLOUR",
      "description": "ARROWROOT FLOUR",
      "fdcId": 20003,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 27,
      "name": "ARUGULA",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "ARUGULA,RAW",
      "fdcId": 11959,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 32,
      "name": "BALSAM-PEAR (BITTER GOURD)",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "BALSAM-PEAR (BITTER GOURD),LEAFY TIPS,RAW",
      "fdcId": 11022,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 34,
      "name": "BAMBOO SHOOTS",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "BAMBOO SHOOTS,RAW",
      "fdcId": 11026,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 37,
      "name": "BASIL",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "SPICES,BASIL,DRIED",
      "fdcId": 2003,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 38,
      "name": "BASIL",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "BASIL,FRESH",
      "fdcId": 2044,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 41,
      "name": "BAY LEAF",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "SPICES,BAY LEAF",
      "fdcId": 2004,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 43,
      "name": "BEAR",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,BEAR,CKD,SIMMRD",
      "fdcId": 17147,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 44,
      "name": "BEAR",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,BEAR,RAW",
      "fdcId": 17146,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 45,
      "name": "BEAVER",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,BEAVER,CKD,RSTD",
      "fdcId": 17151,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 46,
      "name": "BEAVER",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,BEAVER,RAW",
      "fdcId": 17150,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 48,
      "name": "BEEF",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "BEEF,GRASS-FED,GROUND,RAW",
      "fdcId": 13047,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 67,
      "name": "BEET GREENS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "BEET GREENS,RAW",
      "fdcId": 11086,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 68,
      "name": "BEETS",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "BEETS,RAW",
      "fdcId": 11080,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 69,
      "name": "BISON",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,BISON,CHUCK,SHLDR CLOD,LN,3-5 LB RST,CKD,BRSD",
      "fdcId": 17333,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 71,
      "name": "BISON",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,BISON,CHUCK,SHLDR CLOD,LN,3-5 LB RST,RAW",
      "fdcId": 17334,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 75,
      "name": "BLUEBERRIES",
      "category": "FRUIT",
      "subCat": "BERRY",
      "description": "BLUEBERRIES,RAW",
      "fdcId": 9050,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 78,
      "name": "BOAR",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,BOAR,WILD,CKD,RSTD",
      "fdcId": 17159,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 79,
      "name": "BOAR",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,BOAR,WILD,RAW",
      "fdcId": 17158,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 84,
      "name": "BORAGE",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "BORAGE,RAW",
      "fdcId": 11613,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 89,
      "name": "BROCCOLI",
      "category": "VEG",
      "subCat": "FLOWER",
      "description": "BROCCOLI,CHINESE,COOKED",
      "fdcId": 11969,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 90,
      "name": "BROCCOLI",
      "category": "VEG",
      "subCat": "FLOWER",
      "description": "BROCCOLI,RAW",
      "fdcId": 11090,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 91,
      "name": "BROCCOLI",
      "category": "VEG",
      "subCat": "FLOWER",
      "description": "BROCCOLI,STALKS,RAW",
      "fdcId": 11741,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 92,
      "name": "BROCCOLI",
      "category": "VEG",
      "subCat": "FLOWER",
      "description": "BROCCOLI RAAB,RAW",
      "fdcId": 11096,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 93,
      "name": "BRUSSELS SPROUTS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "BRUSSELS SPROUTS,RAW",
      "fdcId": 11098,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 95,
      "name": "BUCKWHEAT",
      "category": "SEED",
      "subCat": "PSUEDO",
      "description": "BUCKWHEAT",
      "fdcId": 20008,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 96,
      "name": "BUFFALO",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,BUFFALO,H2O,CKD,RSTD",
      "fdcId": 17161,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 97,
      "name": "BUFFALO",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,BUFFALO,H2O,RAW",
      "fdcId": 17160,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 100,
      "name": "BURDOCK ROOT",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "BURDOCK ROOT,RAW",
      "fdcId": 11104,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 101,
      "name": "BUTTER",
      "category": "DAIRY",
      "subCat": "OTHER",
      "description": "BUTTER,WITHOUT SALT",
      "fdcId": 1145,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 3,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 105,
      "name": "CABBAGE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CABBAGE,JAPANESE STYLE,FRSH,PICKLED",
      "fdcId": 43143,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 3,
      "tryamine": 1
  },
  {
      "foodId": 107,
      "name": "CABBAGE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CABBAGE,MUSTARD,SALTED",
      "fdcId": 43144,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 108,
      "name": "CABBAGE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CABBAGE,NAPA,COOKED",
      "fdcId": 11970,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 109,
      "name": "CABBAGE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CABBAGE,CHINESE (PAK-CHOI),RAW",
      "fdcId": 11116,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 110,
      "name": "CABBAGE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CABBAGE,COMMON,FRESHLY HARVEST,RAW",
      "fdcId": 11749,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 111,
      "name": "CABBAGE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CABBAGE,RAW",
      "fdcId": 11109,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 112,
      "name": "CABBAGE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CABBAGE,RED,RAW",
      "fdcId": 11112,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 113,
      "name": "CAPERS",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "CAPERS,CANNED",
      "fdcId": 2054,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 115,
      "name": "CARAWAY",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "CARAWAY SEED",
      "fdcId": 2005,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 116,
      "name": "CARDAMOM",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "SPICES,CARDAMOM",
      "fdcId": 2006,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 117,
      "name": "CARIBOU",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,CARIBOU,CKD,RSTD",
      "fdcId": 17163,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 118,
      "name": "CARIBOU",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,CARIBOU,RAW",
      "fdcId": 17162,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 119,
      "name": "CARISSA",
      "category": "FRUIT",
      "subCat": "BERRY",
      "description": "CARISSA,(NATAL-PLUM),RAW",
      "fdcId": 9061,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 122,
      "name": "CARROTS",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "CARROTS,RAW",
      "fdcId": 11124,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 127,
      "name": "CATTAIL",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CATTAIL,NARROW LEAF SHOOTS (NORTHERN PLAINS INDIANS)",
      "fdcId": 35195,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 130,
      "name": "CELERIAC",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "CELERIAC,RAW",
      "fdcId": 11141,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 132,
      "name": "CELERY FLAKES",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "CELERY FLAKES,DRIED",
      "fdcId": 44055,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 133,
      "name": "CELERY SEED",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "CELERY SEED",
      "fdcId": 2007,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 134,
      "name": "CELTUCE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CELTUCE,RAW",
      "fdcId": 11145,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 135,
      "name": "CHARD",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CHARD,SWISS,RAW",
      "fdcId": 11147,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 167,
      "name": "CHERVIL",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "CHERVIL,DRIED",
      "fdcId": 2008,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 172,
      "name": "CHIA SEEDS",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "CHIA SEEDS,DRIED",
      "fdcId": 12006,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 173,
      "name": "CHICKEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "CHICKEN,CORNISH GAME HENS,MEAT ONLY,CKD,RSTD",
      "fdcId": 5310,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 174,
      "name": "CHICKEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "CHICKEN,ROASTING,DK MEAT,MEAT ONLY,CKD,RSTD",
      "fdcId": 5120,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 175,
      "name": "CHICKEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "CHICKEN,ROASTING,MEAT ONLY,CKD,RSTD",
      "fdcId": 5114,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 176,
      "name": "CHICKEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "CHICKEN,ROASTING,MEAT&SKN,CKD,RSTD",
      "fdcId": 5112,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 177,
      "name": "CHICKEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "CHICKEN,BROILERS OR FRYERS,BREAST,MEAT ONLY,RAW",
      "fdcId": 5062,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 178,
      "name": "CHICKEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "CHICKEN,BROILERS OR FRYERS,DK MEAT,MEAT ONLY,RAW",
      "fdcId": 5043,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 179,
      "name": "CHICKEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "CHICKEN,BROILERS OR FRYERS,MEAT & SKN,RAW",
      "fdcId": 5006,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 180,
      "name": "CHICKEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "CHICKEN,BROILERS OR FRYERS,MEAT ONLY,RAW",
      "fdcId": 5011,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 181,
      "name": "CHICKEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "CHICKEN,CORNISH GAME HENS,MEAT ONLY,RAW",
      "fdcId": 5309,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 182,
      "name": "CHICKEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "CHICKEN,ROASTING,DK MEAT,MEAT ONLY,RAW",
      "fdcId": 5119,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 183,
      "name": "CHICKEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "CHICKEN,ROASTING,LT MEAT,MEAT ONLY,RAW",
      "fdcId": 5117,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 189,
      "name": "CHICORY GREENS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CHICORY GREENS,RAW",
      "fdcId": 11152,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 190,
      "name": "CHICORY ROOTS",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "CHICORY ROOTS,RAW",
      "fdcId": 11154,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 192,
      "name": "CHITON",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "CHITON,LEATHERY,GUMBOOTS (ALASKA NATIVE)",
      "fdcId": 35026,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 193,
      "name": "CHIVES",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "CHIVES,RAW",
      "fdcId": 11156,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 194,
      "name": "CHRYSANTHEMUM",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "CHRYSANTHEMUM,GARLAND,RAW",
      "fdcId": 11157,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 195,
      "name": "CHRYSANTHEMUM",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CHRYSANTHEMUM LEAVES,RAW",
      "fdcId": 11698,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 202,
      "name": "CLOUDBERRIES",
      "category": "FRUIT",
      "subCat": "BERRY",
      "description": "CLOUDBERRIES,RAW (ALASKA NATIVE)",
      "fdcId": 35027,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 206,
      "name": "COCONUT",
      "category": "FRUIT",
      "subCat": "DRUPE",
      "description": "COCONUT MEAT,RAW",
      "fdcId": 12104,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 213,
      "name": "COLLARDS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "COLLARDS,RAW",
      "fdcId": 11161,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 215,
      "name": "CORIANDER",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "CORIANDER SEED",
      "fdcId": 2013,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 216,
      "name": "CORIANDER",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "CORIANDER (CILANTRO) LEAVES,RAW",
      "fdcId": 11165,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 220,
      "name": "CORNSTARCH",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "CORNSTARCH",
      "fdcId": 20027,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 221,
      "name": "COTTONSEED",
      "category": "OTHER",
      "subCat": "FLOUR",
      "description": "COTTONSEED FLR,LOFAT (GLANDLESS)",
      "fdcId": 12008,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 228,
      "name": "CRANBERRIES",
      "category": "FRUIT",
      "subCat": "BERRY",
      "description": "CRANBERRIES,RAW",
      "fdcId": 9078,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 236,
      "name": "CRESS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "CRESS,GARDEN,RAW",
      "fdcId": 11203,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 239,
      "name": "CUCUMBER",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "CUCUMBER,WITH PEEL,RAW",
      "fdcId": 11205,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 240,
      "name": "CUMIN",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "CUMIN SEED",
      "fdcId": 2014,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 248,
      "name": "DANDELION GREENS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "DANDELION GREENS,RAW",
      "fdcId": 11207,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 250,
      "name": "DEER",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,DEER,CKD,RSTD",
      "fdcId": 17165,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 251,
      "name": "DEER",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,DEER,TENDERLOIN,LN,0.5-1 LB RST,CKD,BRLD",
      "fdcId": 17347,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 252,
      "name": "DEER",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,DEER,RAW",
      "fdcId": 17164,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 253,
      "name": "DILL",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "DILL SEED",
      "fdcId": 2016,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 254,
      "name": "DILL WEED",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "DILL WEED,FRSH",
      "fdcId": 2045,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 257,
      "name": "DOVE",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "DOVE,CKD (INCL SQUAB)",
      "fdcId": 43287,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 260,
      "name": "DUCK",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "DUCK,DOMESTICATED,MEAT ONLY,CKD,RSTD",
      "fdcId": 5142,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 261,
      "name": "DUCK",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "DUCK,YNG DUCKL,DOM,WH PEKIN,BRST,MEAT,BNLESS,CKD WO/SKN,BRLD",
      "fdcId": 5316,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 262,
      "name": "DUCK",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "DUCK,YNG DUCKL,DOM,WH PEKIN,LEG,MEAT,BONE IN,CKD WO/SKN,BRSD",
      "fdcId": 5318,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 263,
      "name": "DUCK",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "DUCK,DOMESTICATED,MEAT ONLY,RAW",
      "fdcId": 5141,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 282,
      "name": "ELDERBERRIES",
      "category": "FRUIT",
      "subCat": "BERRY",
      "description": "ELDERBERRIES,RAW",
      "fdcId": 9088,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 283,
      "name": "ELK",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,ELK,CKD,RSTD",
      "fdcId": 17167,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 284,
      "name": "ELK",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,ELK,TENDERLOIN,LN,CKD,BRLD",
      "fdcId": 17342,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 285,
      "name": "ELK",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,ELK,RAW",
      "fdcId": 17166,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 286,
      "name": "EMU",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "EMU,FULL RUMP,CKD,BRLD",
      "fdcId": 5627,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 287,
      "name": "EMU",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "EMU,INSIDE DRUMS,CKD,BRLD",
      "fdcId": 5629,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 288,
      "name": "EMU",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "EMU,FULL RUMP,RAW",
      "fdcId": 5626,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 289,
      "name": "EMU",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "EMU,INSIDE DRUM,RAW",
      "fdcId": 5628,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 290,
      "name": "ENDIVE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "ENDIVE,RAW",
      "fdcId": 11213,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 291,
      "name": "EPAZOTE",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "EPAZOTE,RAW",
      "fdcId": 11984,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 294,
      "name": "FENNEL",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "FENNEL,BULB,RAW",
      "fdcId": 11957,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 295,
      "name": "FENNEL",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "FENNEL SEED",
      "fdcId": 2018,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 296,
      "name": "FENUGREEK",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "FENUGREEK SEED",
      "fdcId": 2019,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 297,
      "name": "FIDDLEHEAD FERNS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "FIDDLEHEAD FERNS,RAW",
      "fdcId": 11995,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 299,
      "name": "COD LIVER",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "FISH OIL,COD LIVER",
      "fdcId": 4589,
      "caffeine": 0,
      "egg": 0,
      "fish": 3,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 300,
      "name": "HERRING",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "FISH OIL,HERRING",
      "fdcId": 4590,
      "caffeine": 0,
      "egg": 0,
      "fish": 3,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 301,
      "name": "MENHADEN",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "FISH OIL,MENHADEN",
      "fdcId": 4591,
      "caffeine": 0,
      "egg": 0,
      "fish": 3,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 302,
      "name": "SALMON",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "FISH OIL,SALMON",
      "fdcId": 4593,
      "caffeine": 0,
      "egg": 0,
      "fish": 3,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 303,
      "name": "SARDINE",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "FISH OIL,SARDINE",
      "fdcId": 4594,
      "caffeine": 0,
      "egg": 0,
      "fish": 3,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 306,
      "name": "FLAXSEED",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "FLAXSEED OIL",
      "fdcId": 42231,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 307,
      "name": "FLAXSEED",
      "category": "SEED",
      "subCat": "PSUEDO",
      "description": "SEEDS,FLAXSEED",
      "fdcId": 12220,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 308,
      "name": "FROG LEGS",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "FROG LEGS,RAW",
      "fdcId": 80200,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 310,
      "name": "GARLIC",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "GARLIC,RAW",
      "fdcId": 11215,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 314,
      "name": "GINGER",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "GINGER,GROUND",
      "fdcId": 2021,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 315,
      "name": "GINGER",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "GINGER ROOT,RAW",
      "fdcId": 11216,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 317,
      "name": "GOAT",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,GOAT,CKD,RSTD",
      "fdcId": 17169,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 318,
      "name": "GOAT",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GOAT,RAW",
      "fdcId": 17168,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 319,
      "name": "GOOSE",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "GOOSE,DOMESTICATED,MEAT ONLY,CKD,RSTD",
      "fdcId": 5149,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 320,
      "name": "GOOSE",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "GOOSE,DOMESTICATED,MEAT ONLY,RAW",
      "fdcId": 5148,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 321,
      "name": "GOOSEBERRIES",
      "category": "FRUIT",
      "subCat": "BERRY",
      "description": "GOOSEBERRIES,RAW",
      "fdcId": 9107,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 324,
      "name": "GRAPE LEAVES",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "GRAPE LEAVES,RAW",
      "fdcId": 11974,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 332,
      "name": "GUINEA HEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "GUINEA HEN,MEAT ONLY,RAW",
      "fdcId": 5152,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 333,
      "name": "GUINEA HEN",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "GUINEA HEN,MEAT&SKN,RAW",
      "fdcId": 5151,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 340,
      "name": "HEARTS OF PALM",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "HEARTS OF PALM,CANNED",
      "fdcId": 11961,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 3
  },
  {
      "foodId": 348,
      "name": "HORSE",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,HORSE,CKD,RSTD",
      "fdcId": 17171,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 349,
      "name": "HORSE",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,HORSE,RAW",
      "fdcId": 17170,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 350,
      "name": "HORSERADISH",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "HORSERADISH-TREE,PODS,RAW",
      "fdcId": 11620,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 353,
      "name": "JELLYFISH",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "JELLYFISH,DRIED,SALTED",
      "fdcId": 43497,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 356,
      "name": "JUTE",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "JUTE,POTHERB,RAW",
      "fdcId": 11231,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 357,
      "name": "KALE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "KALE,RAW",
      "fdcId": 11233,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 358,
      "name": "KALE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "KALE,SCOTCH,RAW",
      "fdcId": 11622,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 360,
      "name": "KIWI",
      "category": "FRUIT",
      "subCat": "BERRY",
      "description": "KIWI FRUIT,(CHINESE GOOSEBERRIES),FRSH,RAW",
      "fdcId": 9148,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 361,
      "name": "KIWI",
      "category": "FRUIT",
      "subCat": "BERRY",
      "description": "KIWIFRUIT,(CHINESE GOOSEBERRIES),HELD IN STORAGE,RAW",
      "fdcId": 9405,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 362,
      "name": "KOHLRABI",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "KOHLRABI,RAW",
      "fdcId": 11241,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 366,
      "name": "LAMB",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "LAMB,NZ,IMP,FRZ,COMP OF RTL CUTS,FAT,CKD",
      "fdcId": 17067,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 367,
      "name": "LAMB",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "LAMB,NZ,IMP,FRZ,COMP OF RTL CUTS,FAT,RAW",
      "fdcId": 17066,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 370,
      "name": "LAMBSQUARTERS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "LAMBSQUARTERS,RAW",
      "fdcId": 11244,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 371,
      "name": "LARD",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "FAT,BEEF TALLOW",
      "fdcId": 4001,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 372,
      "name": "LARD",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "FAT,MUTTON TALLOW",
      "fdcId": 4520,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 373,
      "name": "LARD",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "FAT,TURKEY",
      "fdcId": 4575,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 374,
      "name": "LARD",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "LARD",
      "fdcId": 4002,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 375,
      "name": "LARD",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "ANIMAL FAT,BACON GREASE",
      "fdcId": 4609,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 376,
      "name": "LARD",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "MEAT DRIPPINGS (LARD,BF TALLOW,MUTTON TALLOW)",
      "fdcId": 4606,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 378,
      "name": "LEAVENING AGENTS",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "LEAVENING AGENTS,BAKING SODA",
      "fdcId": 18372,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 379,
      "name": "LEAVENING AGENTS",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "LEAVENING AGENTS,CRM OF TARTAR",
      "fdcId": 18373,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 381,
      "name": "LEMON GRASS",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "LEMON GRASS (CITRONELLA),RAW",
      "fdcId": 11972,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 382,
      "name": "LEMONS",
      "category": "FRUIT",
      "subCat": "CITRUS",
      "description": "LEMONS,RAW,WITH PEEL",
      "fdcId": 9151,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 383,
      "name": "LEMONS",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "LEMON JUICE,RAW",
      "fdcId": 9152,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 384,
      "name": "LEMONS",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "LEMON PEEL,RAW",
      "fdcId": 9156,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 388,
      "name": "LETTUCE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "LETTUCE,ICEBERG (INCL CRISPHEAD TYPES),RAW",
      "fdcId": 11252,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 389,
      "name": "LETTUCE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "LETTUCE,BUTTERHEAD (INCL BOSTON&BIBB TYPES),RAW",
      "fdcId": 11250,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 390,
      "name": "LETTUCE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "LETTUCE,COS OR ROMAINE,RAW",
      "fdcId": 11251,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 391,
      "name": "LETTUCE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "LETTUCE,GRN LEAF,RAW",
      "fdcId": 11253,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 392,
      "name": "LETTUCE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "LETTUCE,RED LEAF,RAW",
      "fdcId": 11257,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 394,
      "name": "LIME JUICE",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "LIME JUICE,RAW",
      "fdcId": 9160,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 395,
      "name": "LIMES",
      "category": "FRUIT",
      "subCat": "CITRUS",
      "description": "LIMES,RAW",
      "fdcId": 9159,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 404,
      "name": "LOQUATS",
      "category": "FRUIT",
      "subCat": "POME",
      "description": "LOQUATS,RAW",
      "fdcId": 9174,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 405,
      "name": "LOTUS ROOT",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "LOTUS ROOT,RAW",
      "fdcId": 11254,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 407,
      "name": "MACADAMIA NUTS",
      "category": "SEED",
      "subCat": "ANGIO",
      "description": "MACADAMIA NUTS,RAW",
      "fdcId": 12131,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 416,
      "name": "MASHU ROOTS",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "MASHU ROOTS,RAW (ALASKA NATIVE)",
      "fdcId": 35050,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 417,
      "name": "NAVAJO",
      "category": "FRUIT",
      "subCat": "MELON",
      "description": "MELON,BANANA (NAVAJO)",
      "fdcId": 35132,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 418,
      "name": "CASABA",
      "category": "FRUIT",
      "subCat": "MELON",
      "description": "MELONS,CASABA,RAW",
      "fdcId": 9183,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 419,
      "name": "HONEYDEW",
      "category": "FRUIT",
      "subCat": "MELON",
      "description": "MELONS,HONEYDEW,RAW",
      "fdcId": 9184,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 420,
      "name": "CANTELOPE",
      "category": "FRUIT",
      "subCat": "MELON",
      "description": "MELONS,CANTALOUPE,RAW",
      "fdcId": 9181,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 434,
      "name": "MOOSE",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,MOOSE,CKD,RSTD",
      "fdcId": 17173,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 435,
      "name": "MOOSE",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,MOOSE,RAW",
      "fdcId": 17172,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 436,
      "name": "MORTADELLA",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "MORTADELLA,BEEF,PORK",
      "fdcId": 7050,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 3
  },
  {
      "foodId": 438,
      "name": "MOUNTAIN YAM",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "MOUNTAIN YAM,HAWAII,RAW",
      "fdcId": 11258,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 439,
      "name": "MULBERRIES",
      "category": "FRUIT",
      "subCat": "BERRY",
      "description": "MULBERRIES,RAW",
      "fdcId": 9190,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 450,
      "name": "MUSKRAT",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,MUSKRAT,CKD,RSTD",
      "fdcId": 17175,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 451,
      "name": "MUSKRAT",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,MUSKRAT,RAW",
      "fdcId": 17174,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 455,
      "name": "MUSTARD GREENS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "MUSTARD GRNS,CKD,BLD,DRND,W/SALT",
      "fdcId": 11799,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 456,
      "name": "MUSTARD GREENS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "MUSTARD GRNS,FRZ,CKD,BLD,DRND,W/SALT",
      "fdcId": 11800,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 457,
      "name": "MUSTARD GREENS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "MUSTARD GRNS,FRZ,UNPREP",
      "fdcId": 11272,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 458,
      "name": "MUSTARD GREENS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "MUSTARD GREENS,RAW",
      "fdcId": 11270,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 460,
      "name": "MUSTARD SPINACH",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "MUSTARD SPINACH,(TENDERGREEN),RAW",
      "fdcId": 11274,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 463,
      "name": "NEW ZEALAND SPINACH",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "NEW ZEALAND SPINACH,RAW",
      "fdcId": 11276,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 464,
      "name": "NOPALES",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "NOPALES,RAW",
      "fdcId": 11963,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 475,
      "name": "CORN",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,CORN,PEANUT,AND OLIVE",
      "fdcId": 44005,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 476,
      "name": "OLIVE",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,OLIVE,SALAD OR COOKING",
      "fdcId": 4053,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 480,
      "name": "COCOA",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,COCOA BUTTER",
      "fdcId": 4501,
      "caffeine": 3,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 481,
      "name": "WALRUS",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "OIL,WALRUS (ALASKA NATIVE)",
      "fdcId": 35084,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 482,
      "name": "WHALE",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "OIL,WHALE,BOWHEAD (ALASKA NATIVE)",
      "fdcId": 35087,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 483,
      "name": "PAM",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,PAM COOKING SPRAY,ORIGINAL",
      "fdcId": 4679,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 484,
      "name": "SESAME",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,SESAME,SALAD OR COOKING",
      "fdcId": 4058,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 485,
      "name": "SAFFLOWER",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG SAFFLOWER,SALAD OR COOKING,LINOLEIC,(OVER 70%)",
      "fdcId": 4510,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 486,
      "name": "APRICOT",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,APRICOT KERNEL",
      "fdcId": 4530,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 487,
      "name": "CANOLA",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,CANOLA",
      "fdcId": 4582,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 488,
      "name": "CORN",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,CORN,INDUSTRIAL & RTL,ALLPURP SALAD OR COOKING",
      "fdcId": 4518,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 489,
      "name": "COTTONSEED",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,CTTNSD,SALAD OR COOKING",
      "fdcId": 4502,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 490,
      "name": "CANOLA",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,NATREON CANOLA,HI STABILITY,NON TRANS,HI OLEIC (70%)",
      "fdcId": 4678,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 491,
      "name": "NUTMEG",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,NUTMEG BUTTER",
      "fdcId": 4572,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 492,
      "name": "RICE",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,RICE BRAN",
      "fdcId": 4037,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 493,
      "name": "SUNFLOWER",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,SUNFLOWER,HI OLEIC (70% & OVER)",
      "fdcId": 4584,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 494,
      "name": "SUNFLOWER",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,SUNFLOWER,LINOLEIC (LESS THAN 60%)",
      "fdcId": 4060,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 495,
      "name": "SUNFLOWER",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,SUNFLOWER,LINOLEIC,(APPROX. 65%)",
      "fdcId": 4506,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 496,
      "name": "SUNFLOWER",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,SUNFLOWER,LINOLEIC,(HYDR)",
      "fdcId": 4545,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 497,
      "name": "UCUHUBA",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEG,UCUHUBA BUTTER",
      "fdcId": 4573,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 498,
      "name": "BABASSU",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEGETABLE,BABASSU",
      "fdcId": 4534,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 499,
      "name": "CUPU",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEGETABLE,CUPU ASSU",
      "fdcId": 4541,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 500,
      "name": "GRAPESEED",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEGETABLE,GRAPESEED",
      "fdcId": 4517,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 501,
      "name": "PALM",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEGETABLE,PALM",
      "fdcId": 4055,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 502,
      "name": "POPPYSEED",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEGETABLE,POPPYSEED",
      "fdcId": 4514,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 503,
      "name": "TEASEED",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEGETABLE,TEASEED",
      "fdcId": 4516,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 504,
      "name": "TOMATOSEED",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,VEGETABLE,TOMATOSEED",
      "fdcId": 4515,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 505,
      "name": "WHEAT GREM",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "OIL,WHEAT GERM",
      "fdcId": 4038,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 522,
      "name": "ONION",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "ONION POWDER",
      "fdcId": 2026,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 523,
      "name": "ONIONS",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "ONIONS,RAW",
      "fdcId": 11282,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 524,
      "name": "ONIONS",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "ONIONS,SPRING OR SCALLIONS (INCL TOPS&BULB),RAW",
      "fdcId": 11291,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 525,
      "name": "ONIONS",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "ONIONS,SWT,RAW",
      "fdcId": 11294,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 526,
      "name": "ONIONS",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "ONIONS,WELSH,RAW",
      "fdcId": 11293,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 527,
      "name": "OPOSSUM",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,OPOSSUM,CKD,RSTD",
      "fdcId": 17176,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 530,
      "name": "OREGANO",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "SPICES,OREGANO,DRIED",
      "fdcId": 2027,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 531,
      "name": "OSTRICH",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "OSTRICH,INSIDE LEG,CKD",
      "fdcId": 5645,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 532,
      "name": "OSTRICH",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "OSTRICH,TOP LOIN,CKD",
      "fdcId": 5658,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 533,
      "name": "OSTRICH",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "OSTRICH,INSIDE LEG,RAW",
      "fdcId": 5644,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 534,
      "name": "OSTRICH",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "OSTRICH,TOP LOIN,RAW",
      "fdcId": 5657,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 535,
      "name": "OWL",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "OWL,HORNED,FLESH,RAW (ALASKA NATIVE)",
      "fdcId": 35059,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 544,
      "name": "PARSLEY",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "PARSLEY,RAW",
      "fdcId": 11297,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 545,
      "name": "PARSNIPS",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "PARSNIPS,RAW",
      "fdcId": 11298,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 547,
      "name": "PASTRAMI",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "PASTRAMI,TURKEY",
      "fdcId": 7052,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 3
  },
  {
      "foodId": 548,
      "name": "PASTRAMI",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "PASTRAMI  BF  98% FAT-FREE",
      "fdcId": 7925,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 3
  },
  {
      "foodId": 560,
      "name": "PEARS",
      "category": "FRUIT",
      "subCat": "POME",
      "description": "PEARS,ASIAN,RAW",
      "fdcId": 9340,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 561,
      "name": "PEARS",
      "category": "FRUIT",
      "subCat": "POME",
      "description": "PEARS,RAW",
      "fdcId": 9252,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 564,
      "name": "PEPPERMINT",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "PEPPERMINT,FRESH",
      "fdcId": 2064,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 566,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPER,ANCHO,DRIED",
      "fdcId": 11978,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 567,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPER,BLACK",
      "fdcId": 2030,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 568,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPER,RED OR CAYENNE",
      "fdcId": 2031,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 569,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPERS,CHILI,GRN,CND",
      "fdcId": 11980,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 570,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPERS,JALAPENO,CND,SOL&LIQUIDS",
      "fdcId": 11632,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 571,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPERS,SWT,GRN,CND,SOL&LIQUIDS",
      "fdcId": 11335,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 572,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPERS,SWT,RED,CND,SOL&LIQUIDS",
      "fdcId": 11916,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 573,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPERS,HOT CHILI,GRN,RAW",
      "fdcId": 11670,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 574,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPERS,HOT CHILI,RED,RAW",
      "fdcId": 11819,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 575,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPERS,HUNGARIAN,RAW",
      "fdcId": 11981,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 576,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPERS,JALAPENO,RAW",
      "fdcId": 11979,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 577,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPERS,SWEET,YELLOW,RAW",
      "fdcId": 11951,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 578,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPERS,SWT,GRN,RAW",
      "fdcId": 11333,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 579,
      "name": "PEPPERS",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "PEPPERS,SWT,RED,RAW",
      "fdcId": 11821,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 584,
      "name": "PHEASANT",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "PHEASANT,BREAST,MEAT ONLY,RAW",
      "fdcId": 5155,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 585,
      "name": "PHEASANT",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "PHEASANT,RAW,MEAT ONLY",
      "fdcId": 5154,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 592,
      "name": "PISTACHIO NUTS",
      "category": "SEED",
      "subCat": "PSUEDO",
      "description": "PISTACHIO NUTS,RAW",
      "fdcId": 12151,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 593,
      "name": "PLANTAINS",
      "category": "FRUIT",
      "subCat": "TROPICAL",
      "description": "PLANTAINS,RAW",
      "fdcId": 9277,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 597,
      "name": "POMEGRANATES",
      "category": "FRUIT",
      "subCat": "TROPICAL",
      "description": "POMEGRANATES,RAW",
      "fdcId": 9286,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 601,
      "name": "PORK",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "PORK,FRSH,ENHANCED,LOIN,TENDERLOIN,LN & FAT,CKD,RSTD",
      "fdcId": 10952,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 602,
      "name": "PORK",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "PORK,FRSH,LOIN,TENDERLOIN,LN&FAT,CKD,BRLD",
      "fdcId": 10221,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 603,
      "name": "PORK",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "PORK  FRSH  LOIN  TENDERLOIN   LN ONLY  RAW",
      "fdcId": 10060,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 604,
      "name": "PORK",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "PORK,FRSH,ENHANCED,LOIN,TENDERLOIN,LN & FAT,RAW",
      "fdcId": 10951,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 611,
      "name": "POTATOES",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "POTATO,FLESH & SKN,RAW",
      "fdcId": 11352,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 612,
      "name": "POTATOES",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "POTATOES,RAW,SKIN",
      "fdcId": 11362,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 613,
      "name": "POTATOES",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "POTATOES,RED,FLESH & SKN,RAW",
      "fdcId": 11355,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 614,
      "name": "POTATOES",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "POTATOES,RUSSET,FLESH & SKN,RAW",
      "fdcId": 11353,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 615,
      "name": "POTATOES",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "POTATOES,WHITE,FLESH & SKN,RAW",
      "fdcId": 11354,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 616,
      "name": "POTATOES",
      "category": "OTHER",
      "subCat": "FLOUR",
      "description": "POTATO FLOUR",
      "fdcId": 11413,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 617,
      "name": "POULTRY",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "FAT,CHICKEN",
      "fdcId": 4542,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 618,
      "name": "POULTRY",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "FAT,DUCK",
      "fdcId": 4574,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 619,
      "name": "POULTRY",
      "category": "OTHER",
      "subCat": "OIL-M",
      "description": "FAT,GOOSE",
      "fdcId": 4576,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 622,
      "name": "PRICKLY PEARS",
      "category": "FRUIT",
      "subCat": "SUCC",
      "description": "PRICKLY PEARS,RAW",
      "fdcId": 9287,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 624,
      "name": "PUMPKIN FLOWERS",
      "category": "VEG",
      "subCat": "FLOWER",
      "description": "PUMPKIN FLOWERS,RAW",
      "fdcId": 11416,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 625,
      "name": "PUMPKIN LEAVES",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "PUMPKIN LEAVES,RAW",
      "fdcId": 11418,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 626,
      "name": "PUMPKIN PIE SPICE",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "PUMPKIN PIE SPICE",
      "fdcId": 2035,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 627,
      "name": "PURSLANE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "PURSLANE,RAW",
      "fdcId": 11427,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 628,
      "name": "QUAIL",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "QUAIL,COOKED,TOTAL EDIBLE",
      "fdcId": 43282,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 629,
      "name": "QUAIL",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "QUAIL,BREAST,MEAT ONLY,RAW",
      "fdcId": 5159,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 630,
      "name": "QUINCES",
      "category": "FRUIT",
      "subCat": "POME",
      "description": "QUINCES,RAW",
      "fdcId": 9296,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 631,
      "name": "RABBIT",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,RABBIT,DOMESTICATED,COMP OF CUTS,CKD,RSTD",
      "fdcId": 17178,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 632,
      "name": "RABBIT",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,RABBIT,DOMESTICATED,COMP OF CUTS,RAW",
      "fdcId": 17177,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 633,
      "name": "RACCOON",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,RACCOON,CKD,RSTD",
      "fdcId": 17182,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 634,
      "name": "RADICCHIO",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "RADICCHIO,RAW",
      "fdcId": 11952,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 635,
      "name": "RADISHES",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "RADISHES,ORIENTAL,RAW",
      "fdcId": 11430,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 636,
      "name": "RADISHES",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "RADISHES,RAW",
      "fdcId": 11429,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 637,
      "name": "RADISHES",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "RADISHES,WHITE ICICLE,RAW",
      "fdcId": 11637,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 638,
      "name": "RASPBERRIES",
      "category": "FRUIT",
      "subCat": "BERRY",
      "description": "RASPBERRIES,RAW",
      "fdcId": 9302,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 639,
      "name": "RHUBARB",
      "category": "FRUIT",
      "subCat": "LIKE",
      "description": "RHUBARB,RAW",
      "fdcId": 9307,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 640,
      "name": "RICE",
      "category": "SEED",
      "subCat": "CEREAL",
      "description": "RICE,BROWN,LONG-GRAIN,CKD",
      "fdcId": 20037,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 641,
      "name": "RICE",
      "category": "SEED",
      "subCat": "CEREAL",
      "description": "RICE,BROWN,LONG-GRAIN,RAW",
      "fdcId": 20036,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 642,
      "name": "RICE",
      "category": "SEED",
      "subCat": "CEREAL",
      "description": "RICE,BROWN,MEDIUM-GRAIN,RAW",
      "fdcId": 20040,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 643,
      "name": "RICE",
      "category": "SEED",
      "subCat": "CEREAL",
      "description": "RICE,WHITE,LONG-GRAIN,REG,CKD,ENR,W/SALT",
      "fdcId": 20345,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 1,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 644,
      "name": "RICE",
      "category": "SEED",
      "subCat": "CEREAL",
      "description": "RICE,WHITE,SHORT-GRAIN,CKD,UNENR",
      "fdcId": 20453,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 1,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 645,
      "name": "RICE",
      "category": "SEED",
      "subCat": "CEREAL",
      "description": "RICE,WHITE,GLUTINOUS,RAW",
      "fdcId": 20054,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 1,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 646,
      "name": "RICE",
      "category": "SEED",
      "subCat": "CEREAL",
      "description": "RICE,WHITE,LONG-GRAIN,REG,RAW,ENR",
      "fdcId": 20044,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 1,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 647,
      "name": "RICE",
      "category": "SEED",
      "subCat": "CEREAL",
      "description": "RICE,WHITE,LONG-GRAIN,REG,RAW,UNENR",
      "fdcId": 20444,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 1,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 648,
      "name": "RICE",
      "category": "SEED",
      "subCat": "CEREAL",
      "description": "RICE,WHITE,MEDIUM-GRAIN,RAW,ENR",
      "fdcId": 20050,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 1,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 649,
      "name": "RICE",
      "category": "SEED",
      "subCat": "CEREAL",
      "description": "RICE,WHITE,MEDIUM-GRAIN,RAW,UNENR",
      "fdcId": 20450,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 1,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 650,
      "name": "RICE",
      "category": "SEED",
      "subCat": "CEREAL",
      "description": "RICE,WHITE,SHORT-GRAIN,RAW",
      "fdcId": 20052,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 1,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 651,
      "name": "RICE",
      "category": "SEED",
      "subCat": "CEREAL",
      "description": "RICE,WHITE,SHORT-GRAIN,RAW,UNENR",
      "fdcId": 20452,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 1,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 652,
      "name": "RICE FLOUR",
      "category": "OTHER",
      "subCat": "FLOUR",
      "description": "RICE FLOUR,BROWN",
      "fdcId": 20090,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 653,
      "name": "RICE FLOUR",
      "category": "OTHER",
      "subCat": "FLOUR",
      "description": "RICE FLOUR,WHITE",
      "fdcId": 20061,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 658,
      "name": "ROSE-APPLES",
      "category": "FRUIT",
      "subCat": "DRUPE",
      "description": "ROSE-APPLES,RAW",
      "fdcId": 9312,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 659,
      "name": "ROSEMARY",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "ROSEMARY,FRESH",
      "fdcId": 2063,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 662,
      "name": "RUTABAGAS",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "RUTABAGAS,RAW",
      "fdcId": 11435,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 669,
      "name": "SAFFRON",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "SAFFRON",
      "fdcId": 2037,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 670,
      "name": "SAGE",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "SAGE,GROUND",
      "fdcId": 2038,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 678,
      "name": "SALMONBERRIES",
      "category": "FRUIT",
      "subCat": "BERRY",
      "description": "SALMONBERRIES,RAW (ALASKA NATIVE)",
      "fdcId": 35154,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 679,
      "name": "SALT",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "SALT,TABLE",
      "fdcId": 2047,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 680,
      "name": "SAPODILLA",
      "category": "FRUIT",
      "subCat": "POME",
      "description": "SAPODILLA,RAW",
      "fdcId": 9313,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 681,
      "name": "SAPOTES",
      "category": "FRUIT",
      "subCat": "DRUPE",
      "description": "SAPOTES,(MARMALADE PLUM),RAW",
      "fdcId": 9314,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 693,
      "name": "SAVORY",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "SAVORY,GROUND",
      "fdcId": 2039,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 701,
      "name": "SEA LION",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "SEA LION,STELLAR,MEAT (ALASKA NATIVE)",
      "fdcId": 35229,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 702,
      "name": "SEA LION",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "SEA LION,STELLAR,MEAT W/ FAT (ALASKA NATIVE)",
      "fdcId": 35230,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 703,
      "name": "SEAL",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "SEAL,BEARDED (OOGRUK),MEAT,LO QUADRANT,RAW (ALASKA NATIVE)",
      "fdcId": 35170,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 704,
      "name": "SEAL",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "SEAL,BEARDED (OOGRUK),MEAT,RAW (ALASKA NATIVE)",
      "fdcId": 35056,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 707,
      "name": "SEAWEED",
      "category": "VEG",
      "subCat": "SEA",
      "description": "SEAWEED,AGAR,DRIED",
      "fdcId": 11663,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 708,
      "name": "SEAWEED",
      "category": "VEG",
      "subCat": "SEA",
      "description": "SEAWEED,SPIRULINA,DRIED",
      "fdcId": 11667,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 711,
      "name": "SESAME BUTTER",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "SESAME BUTTER,TAHINI,KRNLS UNSPEC",
      "fdcId": 12698,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 712,
      "name": "SESAME FLOUR",
      "category": "OTHER",
      "subCat": "FLOUR",
      "description": "SESAME FLOUR,HIGH-FAT",
      "fdcId": 12170,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 713,
      "name": "SESAME FLOUR",
      "category": "OTHER",
      "subCat": "FLOUR",
      "description": "SESAME FLOUR,LOW-FAT",
      "fdcId": 12033,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 736,
      "name": "SOY FLOUR",
      "category": "OTHER",
      "subCat": "FLOUR",
      "description": "SOY FLOUR,FULL-FAT,RAW",
      "fdcId": 16115,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 3
  },
  {
      "foodId": 747,
      "name": "SPEARMINT",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "SPEARMINT,FRESH",
      "fdcId": 2065,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 751,
      "name": "SQUAB",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "SQUAB,(PIGEON),LT MEAT WO/SKN,RAW",
      "fdcId": 5162,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 752,
      "name": "SQUAB",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "SQUAB,(PIGEON),MEAT ONLY,RAW",
      "fdcId": 5161,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 753,
      "name": "SQUASH",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "SQUASH,ZUCCHINI,BABY,RAW",
      "fdcId": 11953,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 754,
      "name": "SQUASH",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "SQUASH,INDIAN,RAW (NAVAJO)",
      "fdcId": 35138,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 755,
      "name": "SQUASH",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "SQUASH,SUMMER,SCALLOP,RAW",
      "fdcId": 11475,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 756,
      "name": "SQUASH",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "SQUASH,WINTER,ACORN,RAW",
      "fdcId": 11482,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 759,
      "name": "SQUIRREL",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,SQUIRREL,CKD,RSTD",
      "fdcId": 17184,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 760,
      "name": "SQUIRREL",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "GAME MEAT,SQUIRREL,RAW",
      "fdcId": 17183,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 773,
      "name": "SUNFLOWER",
      "category": "OTHER",
      "subCat": "FLOUR",
      "description": "SUNFLOWER SD FLR,PART DEFATTED",
      "fdcId": 12041,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 774,
      "name": "SUNFLOWER",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "SUNFLOWER SD BUTTER,W/SALT",
      "fdcId": 12540,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 776,
      "name": "SWAMP CABBAGE",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "SWAMP CABBAGE,(SKUNK CABBAGE),RAW",
      "fdcId": 11503,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 777,
      "name": "SWEET POTATO",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "SWEET POTATO,RAW,UNPREP",
      "fdcId": 11507,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 778,
      "name": "SWEET POTATO LEAVES",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "SWEET POTATO LEAVES,RAW",
      "fdcId": 11505,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 786,
      "name": "TAMARINDS",
      "category": "FRUIT",
      "subCat": "DRUPE",
      "description": "TAMARINDS,RAW",
      "fdcId": 9322,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 792,
      "name": "TARRAGON",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "SPICES,TARRAGON,DRIED",
      "fdcId": 2041,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 793,
      "name": "THYME",
      "category": "OTHER",
      "subCat": "INGR",
      "description": "THYME,FRSH",
      "fdcId": 2049,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 0,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 794,
      "name": "THYME",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "SPICES,THYME,DRIED",
      "fdcId": 2042,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 823,
      "name": "TURKEY",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "TURKEY,ALL CLASSES,DK MEAT,CKD,RSTD",
      "fdcId": 5188,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 824,
      "name": "TURKEY",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "TURKEY,ALL CLASSES,LT MEAT,CKD,RSTD",
      "fdcId": 5186,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 825,
      "name": "TURKEY",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "TURKEY,FRYER-ROASTERS,DK MEAT,MEAT ONLY,CKD,RSTD",
      "fdcId": 5212,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 826,
      "name": "TURKEY",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "TURKEY,FRYER-ROASTERS,LT MEAT,MEAT ONLY,CKD,RSTD",
      "fdcId": 5210,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 827,
      "name": "TURKEY",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "TURKEY BREAST MEAT",
      "fdcId": 7079,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 828,
      "name": "TURKEY",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "TURKEY,ALL CLASSES,DK MEAT,RAW",
      "fdcId": 5187,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 829,
      "name": "TURKEY",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "TURKEY,ALL CLASSES,LT MEAT,RAW",
      "fdcId": 5185,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 830,
      "name": "TURKEY",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "TURKEY,FRYER-ROASTERS,DK MEAT,MEAT ONLY,RAW",
      "fdcId": 5211,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 831,
      "name": "TURKEY",
      "category": "MEAT",
      "subCat": "POULTRY",
      "description": "TURKEY,FRYER-ROASTERS,LT MEAT,MEAT ONLY,RAW",
      "fdcId": 5209,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 832,
      "name": "TURMERIC",
      "category": "OTHER",
      "subCat": "SEASON",
      "description": "TURMERIC,GROUND",
      "fdcId": 2043,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 3,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 833,
      "name": "TURNIPS",
      "category": "VEG",
      "subCat": "BULBSTEM",
      "description": "TURNIPS,RAW",
      "fdcId": 11564,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 834,
      "name": "TURNIPS",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "TURNIP GREENS,RAW",
      "fdcId": 11568,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 837,
      "name": "VEAL",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "VEAL,BREAST,FAT,CKD",
      "fdcId": 17270,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 838,
      "name": "VEAL",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "VEAL,SIRLOIN,LN&FAT,CKD,BRSD",
      "fdcId": 17135,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 839,
      "name": "VEAL",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "VEAL,BREAST,WHL,BNLESS,LN&FAT,RAW",
      "fdcId": 17271,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 840,
      "name": "VEAL",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "VEAL,LOIN,LN&FAT,RAW",
      "fdcId": 17104,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 841,
      "name": "AVOCADO",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "VEGETABLE OIL,AVOCADO",
      "fdcId": 4581,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 842,
      "name": "COCONUT",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "VEGETABLE OIL,COCONUT",
      "fdcId": 4047,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 843,
      "name": "MUTARD",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "VEGETABLE OIL,MUSTARD",
      "fdcId": 4583,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 844,
      "name": "OAT",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "VEGETABLE OIL,OAT",
      "fdcId": 4588,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 845,
      "name": "PALM",
      "category": "OTHER",
      "subCat": "OIL-P",
      "description": "VEGETABLE OIL,PALM KERNEL",
      "fdcId": 4513,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 851,
      "name": "VINESPINACH",
      "category": "VEG",
      "subCat": "LEAF",
      "description": "VINESPINACH,(BASELLA),RAW",
      "fdcId": 11587,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 853,
      "name": "WALRUS",
      "category": "MEAT",
      "subCat": "RED MEAT",
      "description": "WALRUS,MEAT,RAW (ALASKA NATIVE)",
      "fdcId": 35081,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 854,
      "name": "WASABI",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "WASABI,ROOT,RAW",
      "fdcId": 11990,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 855,
      "name": "WATERCHESTNUTS",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "WATERCHESTNUTS,CHINESE,(MATAI),RAW",
      "fdcId": 11588,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 856,
      "name": "WATERCRESS",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "WATERCRESS,RAW",
      "fdcId": 11591,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 858,
      "name": "WAXGOURD",
      "category": "VEG",
      "subCat": "FRUIT",
      "description": "WAXGOURD,(CHINESE PRESERVING MELON),RAW",
      "fdcId": 11593,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 3,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 886,
      "name": "YAM",
      "category": "VEG",
      "subCat": "ROOT",
      "description": "YAM,RAW",
      "fdcId": 11601,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 2,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 1
  },
  {
      "foodId": 893,
      "name": "",
      "category": "BEVERAGE",
      "subCat": "CARBONATED BEV",
      "description": "CARBONATED BEV,TONIC H2O",
      "fdcId": 14155,
      "caffeine": 3,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 3,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 894,
      "name": "COFFEE",
      "category": "BEVERAGE",
      "subCat": "COFFEE",
      "description": "COFFEE,BREWED FROM GROUNDS,PREP W/ TAP H2O",
      "fdcId": 14209,
      "caffeine": 3,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 895,
      "name": "COFFEE",
      "category": "BEVERAGE",
      "subCat": "COFFEE",
      "description": "COFFEE,BREWED,ESPRESSO,REST-PREP",
      "fdcId": 14210,
      "caffeine": 3,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 896,
      "name": "COFFEE",
      "category": "BEVERAGE",
      "subCat": "COFFEE",
      "description": "COFFEE,DRY,PDR,W/ WHTNR,RED CAL",
      "fdcId": 43401,
      "caffeine": 3,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 897,
      "name": "COFFEE",
      "category": "BEVERAGE",
      "subCat": "COFFEE",
      "description": "COFFEE,INST,REG,PDR",
      "fdcId": 14214,
      "caffeine": 3,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 3,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 898,
      "name": "COFFEE",
      "category": "BEVERAGE",
      "subCat": "COFFEE",
      "description": "COFFEE,BREWED FROM GROUNDS,PREP W/ TAP H2O,DECAFFEINATED",
      "fdcId": 14201,
      "caffeine": 2,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 899,
      "name": "COFFEE",
      "category": "BEVERAGE",
      "subCat": "COFFEE",
      "description": "COFFEE,BREWED,ESPRESSO,REST-PREP,DECAFFEINATED",
      "fdcId": 14202,
      "caffeine": 2,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 900,
      "name": "COFFEE",
      "category": "BEVERAGE",
      "subCat": "COFFEE",
      "description": "COFFEE,INST,DECAFFEINATED,PDR",
      "fdcId": 14218,
      "caffeine": 2,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 1,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 902,
      "name": "WATER",
      "category": "BEVERAGE",
      "subCat": "WATER",
      "description": "WATER,BTLD,GENERIC",
      "fdcId": 14555,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  },
  {
      "foodId": 903,
      "name": "WATER",
      "category": "BEVERAGE",
      "subCat": "WATER",
      "description": "WATER,TAP,DRINKING",
      "fdcId": 14411,
      "caffeine": 0,
      "egg": 0,
      "fish": 0,
      "fodmap": 0,
      "fructose": 0,
      "gluten": 0,
      "histamine": 1,
      "lactose": 0,
      "lectin": 0,
      "legume": 0,
      "nut": 0,
      "oxalte": 0,
      "salicylates": 0,
      "shellfish": 0,
      "soy": 0,
      "sulfites": 0,
      "tryamine": 0
  }
]

export default goodList;